import { render, staticRenderFns } from "./FertilizerModal.vue?vue&type=template&id=56effe4c&"
import script from "./FertilizerModal.vue?vue&type=script&lang=js&"
export * from "./FertilizerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports